import { mergeProperties } from "../components/Utility";
import ActionDropdown from "../components/actions/ActionDropdown";
import Image from "../components/common/Image";
import React from "react";

export const getFormData = (data) => {
    const initialData = {
        name: '',
        image: '',
        status: '1',
        stock: '',
        sellPrice: '',
        tags: '',
        lowStockThreshold: 0,
        availability: '',
        additionalDetails: {
            isVeg: false
        },
        description: '',
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getProductReportFormData = (data) => {
    const initialData = {
        startDate: '',
        endDate: '',
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getTableColumns = () => {
    let tableColumns = [
        { header: "Name", field: "name" },
        { header: "Tags", field: "tags" },
        { header: "Stock", field: "stock" },
        { header: "Sell Price", field: "sellPrice" },
        { header: "Price", field: "price" },
        { header: "Availability", field: "availability" },
    ];

    tableColumns.push({
        header: 'Action',
        disableSorting: true,
        field: 'action',
        align: "right",
        render: (row) => {
            return <ActionDropdown row={row} history={true} />;
        },
    });

    return tableColumns;
};

export const getTableData = ({ items = [] }) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        id: item.id,
        productTemplate: item.productTemplate,
        tags: item.tags.map(tag => tag.name).join(", "),
        restaurant: item.restaurant,
        stock: item.stock,
        sellPrice: item.sellPrice,
        price: item.price,
        availability: item.availability ? "Yes" : "No",
        variations: item.variations,
        name: item.name,
        image: item.image,
    }));
}

export const getEditableTableColumns = () => {
    let tableColumns = [
        { header: "Name", field: "name" },
        { header: "Stock", field: "stock", editable: true },
        {
            header: <div style={{ width: 200 }}>GST</div>,
            field: "gst",
            editable: true,
            type: "select"
        },
        { header: "Sell Price", field: "sellPrice", editable: true },
        { header: "Price", field: "price", editable: true },
        { header: "Stock Threshold", field: "lowStockThreshold", editable: true },
        { header: "Availability", field: "availability", editable: true, type: "boolean" }
    ];
    return tableColumns;
};

export const getEditableTableData = ({ items = [] }) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        id: item.id,
        name: item.name,
        gst: item.gst,
        stock: item.stock,
        lowStockThreshold: item.lowStockThreshold,
        sellPrice: item.sellPrice,
        price: item.price,
        availability: item.availability,
    }));
}

export const getStockEditableTableColumns = () => {
    let tableColumns = [
        { header: "Name", field: "name" },
        { header: "Stock", field: "stock", editable: true },
        { header: "Stock Threshold", field: "lowStockThreshold", editable: true },
        { header: "Availability", field: "availability", editable: true, type: "boolean" }
    ];
    return tableColumns;
};

export const getStockEditableTableData = ({ items = [] }) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        id: item.id,
        name: item.name,
        stock: item.stock,
        lowStockThreshold: item.lowStockThreshold,
        availability: item.availability,
    }));
}

export const getDetailData = ({ item }) => {
    if (!item) return { details: {} };
    return {
        details: {
            name: item.name,
            image: <Image className="border rounded-2" src={item.image} alt={item.name} />,
            tags: item.tags.map(tag => tag.name).join(", "),
            price: item.price,
            sellPrice: item.sellPrice,
            stock: item.stock,
            isVeg: item.additionalDetails?.isVeg ? "Yes" : "No",
            availability: item.availability ? "Yes" : "No",
            status: item.status ? "Active" : "Inactive",
        }
    };
}


export const getProductReportTableColumns = () => {
    let tableColumns = [
        { header: "Name", field: "name" },
        { header: "Units Sold", field: "totalQuantity" },
        { header: "Avg. Unit Solds ", field: "averageQuantity" },
    ];

    return tableColumns;
};

export const getProductReportTableData = ({ items = [] }) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        name: item.name,
        totalQuantity: item.totalQuantity,
        averageQuantity: item.averageQuantity
    }));
}









